export default __webpack_public_path__ + "static/right_c2a_arrow-64ba8ef211b9b551679a5b3da62afc60.png";